module.exports = __webpack_public_path__ + "static/media/cProject-banner-new.b46c23fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/cProject-banner-new.png
// module id = 495
// module chunks = 0